import { Navigate, Route, Routes } from 'react-router-dom';
import AdministrationHeader from 'components/pages/Administration/AdministrationHeader';
import { PageWrapper } from 'components/common/layout/PageWrapper/PageWrapper';
import { ChildRoute } from 'components/common/types/Route.types';
import PrivateRoute from 'components/common/Auth/Private';
import SingleContent from 'components/common/layout/SingleContent';
import CreativeAdministration from './CreativeAdministration';

const Administration: React.FC = () => {
  const childRoutes: ChildRoute[] = [
    {
      id: 1,
      path: `creatives`,
      main: () => <SingleContent content={<CreativeAdministration />} />,
      pageAccessPermission: undefined,
    },
    {
      id: 2,
      path: '*',
      main: () => <Navigate to="creatives" />,
      pageAccessPermission: undefined,
    },
  ];

  return (
    <PageWrapper>
      <AdministrationHeader />
      <Routes>
        {childRoutes.map((route) => (
          <Route
            key={route.id}
            path={route.path}
            element={<PrivateRoute component={route.main} pageAccessPermission={route.pageAccessPermission} />}
          />
        ))}
      </Routes>
    </PageWrapper>
  );
};

export default Administration;
